import { CSSResultArray, html, TemplateResult } from 'lit';
import { OutlineElement } from '@phase2/outline-core';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './pc-form-block.css.lit';
import globalStyles from './pc-form-block.lightDom.css.lit';
import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';

/**
 * The Form Block component.
 * @element pc-form-block
 * @slot - default slot
 */
@customElement('pc-form-block')
export class PCFormBlock extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];
  adoptedStylesheets: AdoptedStyleSheets;

  /**
   * If set removes vertical padding
   */
  @property({ type: Boolean })
  trim: boolean;

  connectedCallback(): void {
    super.connectedCallback();
    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);
  }

  render(): TemplateResult {
    return html`
      <pc-container full-bleed>
        <div class="form-block">
          <slot></slot>
        </div>
      </pc-container>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-form-block': PCFormBlock;
  }
}
